import React from "react";
import PropTypes from "prop-types";
import { Row, Col, Card, Tag, Tooltip } from "antd";
import { toSetString, toDateString, toUSDCurrency } from "../../../helpers/converters";
import Renew from "./renewal";
import { EditOutlined } from "@ant-design/icons";
import { withUser } from "@unifiedpatents/sso";

const styles = {
  verticalGutter: {
    marginBottom: 8
  }
};

const BiographicData = props => {
  const { data } = props;
  const {
    status: { isLoggedIn, isAdmin }
  } = props.user;
  const canEdit = isLoggedIn && isAdmin;
  const editButton = (canEdit, ucid) => {
    return canEdit ? (
      <a href={`https://annie.unifiedpatents.com/name-correction/${ucid}`}>
        <EditOutlined />
      </a>
    ) : (
      undefined
    );
  };
  return (
    <Card title="Details" extra={<Renew ucid={data.publication_number} />}>
      <Row gutter={16}>
        <Col span={24} lg={8}>
          <div style={styles.verticalGutter}>
            <strong>{"Grant Number:"}</strong> {data.grant_number}
          </div>
          <div style={styles.verticalGutter}>
            <strong>{"Publication Number:"}</strong> {data.publication_number}
          </div>
          <div style={styles.verticalGutter}>
            <strong>{"Application Number:"}</strong> {data.application_number}
          </div>
          <div style={styles.verticalGutter}>
            <strong>{"CPC Class:"}</strong> {data.cpc_class.sort().join(",")}
          </div>
          <div style={styles.verticalGutter}>
            <strong>{"Inventors:"}</strong> {toSetString(data.inventors)}
          </div>
          <div style={styles.verticalGutter}>
            <strong>{"Examiner:"}</strong> {toSetString(data.examiner)}
          </div>
        </Col>
        <Col span={24} lg={8}>
          <div style={styles.verticalGutter}>
            <strong>{"Priority Date:"}</strong> {toDateString(data.priority_date)}
          </div>
          <div style={styles.verticalGutter}>
            <strong>{"Application Date:"}</strong> {toDateString(data.application_date)}
          </div>
          <div style={styles.verticalGutter}>
            <strong>{"Grant Date:"}</strong> {toDateString(data.publication_date)}
          </div>
          <div style={styles.verticalGutter}>
            <strong>{"Expiration Date:"}</strong> {toDateString(data.expiration_date)}
          </div>
          <div style={styles.verticalGutter}>
            <strong>{"Lifetime Renewal Fees:"}</strong> {!isNaN(data.annuities) ? toUSDCurrency(Math.round(data.annuities / 10) * 10) : ""}
          </div>
          <div style={styles.verticalGutter}>
            <strong>{"Lifetime Family Renewal Fees:"}</strong> {!isNaN(data.family_annuities) ? toUSDCurrency(Math.round(data.family_annuities / 10) * 10) : ""}
          </div>
        </Col>
        <Col span={24} lg={8}>
          <div style={styles.verticalGutter}>
            <strong>{"Parent Company:"}</strong>
            {editButton(canEdit, data.publication_number)}
            {toSetString(data.assignee_parent)}{" "}
          </div>
          <div style={styles.verticalGutter}>
            <strong>{"Original Assignee:"}</strong>
            {editButton(canEdit, data.publication_number)}
            {toSetString(data.assignee_original)}
          </div>
          <div style={styles.verticalGutter}>
            <strong>{"Current Assignee:"}</strong> {editButton(canEdit, data.publication_number)}
            {toSetString(data.assignee_current)}
            {data.transaction_type ? (
              <Tooltip title="You will leave Unified Patents Portal and be directed to Richardson Oliver Insights.">
                <a target="_new" rel="nofollow" href={data.transaction_ro_url}>
                  <Tag color="blue" style={{ cursor: "pointer" }}>
                    {data.transaction_type}
                  </Tag>
                </a>
              </Tooltip>
            ) : null}
          </div>
        </Col>
      </Row>
    </Card>
  );
};

BiographicData.propTypes = {
  data: PropTypes.object.isRequired
};

export default withUser(BiographicData);
